<umkt-auth-layout>
  <div class="auth-back">
    <a routerLink="/">
      <mat-icon>chevron_left</mat-icon>
      {{ 'shared.buttons.back' | i18n }}
    </a>
  </div>
  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title font-highlight">
          <h1>{{ 'pages.login.title' | i18n }} <span class="auth-title-highlight">{{ 'pages.login.titleHighlight' | i18n }}</span></h1>
        </div>
        <div *ngIf="isLoading">
          <h2 class="auth-sub-title">{{ 'pages.confirmEmail.loading.title' | i18n }}</h2>
          <p class="auth-desc">
            {{ 'pages.confirmEmail.loading.description' | i18n }}
          </p>
        </div>

        <div *ngIf="!isLoading && confirmationStatus === 'success'" class="success-state">
          <h2 class="auth-sub-title">{{ 'pages.confirmEmail.success.title' | i18n }}</h2>
          <p class="auth-desc">
            {{ 'pages.confirmEmail.success.description' | i18n }}
          </p>

          <ustore-button [type]="'submit'" [format]="'filled'" [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'"
            [size]="'medium'" [rounded]="'default'" [text]="'pages.confirmEmail.success.button' | i18n"
            [icon]="{ name: 'login', type: 'material-icons', position: 'left' }" [full]="true" (click)="enterNow()">
          </ustore-button>
        </div>

        <div *ngIf="!isLoading && confirmationStatus === 'error'" class="error-state">
          <h2 class="auth-sub-title">{{ 'pages.confirmEmail.error.title' | i18n }}</h2>
          <p class="auth-desc">
            {{ errorMessage | i18n }}
          </p>
          <ustore-button 
            [type]="'submit'" 
            [format]="'filled'" 
            [backgroundColor]="'var(--color-red-500-to-yellow)'" 
            [textColor]="'var(--color-inverted)'"
            [size]="'medium'" 
            [rounded]="'default'"
            [text]="'pages.confirmEmail.error.button' | i18n"
            [icon]="{ name: 'login', type: 'material-icons', position: 'left' }" 
            [full]="true" 
            (click)="enterNow()">
          </ustore-button>
        </div>
      </div>
    </div>
  </div>
</umkt-auth-layout>